import PreviewSection from "./PreviewSection";
import { generateQuoteCheckPreview } from "../utils/previewGenerators.jsx";

function QuoteCheckPreview({ formData, currentStep }) {
  const preview = generateQuoteCheckPreview(formData, currentStep);

  if (!preview) {
    return null;
  }

  return (
    <div className="email-preview">
      <h3><i className="fas fa-eye"></i> Email Preview</h3>
      <PreviewSection title={preview.title}>{preview.content}</PreviewSection>
    </div>
  );
}

export default QuoteCheckPreview;
